import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import { Table, Typography, Grid, Flex } from "antd";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "@inscore/shared";
const { Title, Text } = Typography;
const { useBreakpoint } = Grid;
const StatsTable = ({
  tableData,
  children,
  renderNewVersion = true,
  onSortChange,
  onRowClick
}) => {
  const screens = useBreakpoint();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const handleRowEvents = (record) => ({
    onClick: () => {
      if (onRowClick)
        onRowClick(record);
      else
        navigate(`/team/${record.teamId}`);
    }
  });
  return /* @__PURE__ */ jsxs(Flex, { vertical: true, gap: 16, style: { position: "relative" }, children: [
    children && /* @__PURE__ */ jsxs(
      Flex,
      {
        align: screens.md ? "center" : "start",
        justify: "space-between",
        gap: 16,
        vertical: !screens.md,
        children: [
          !renderNewVersion && screens.md && /* @__PURE__ */ jsx(Title, { level: 5, style: { margin: 0 }, children: tableData.tableName }),
          children
        ]
      }
    ),
    /* @__PURE__ */ jsxs(Flex, { vertical: true, gap: 12, children: [
      /* @__PURE__ */ jsx(
        Table,
        {
          columns: tableData.columns,
          dataSource: tableData.dataSource,
          pagination: false,
          onRow: handleRowEvents,
          showSorterTooltip: false,
          onChange: (_pagination, _filters, sorter, { action }) => {
            if (action !== "sort")
              return;
            onSortChange == null ? void 0 : onSortChange({
              sortBy: sorter.order ? sorter.columnKey : void 0,
              sortOrder: sorter.order
            });
          },
          className: `bottom-border-only-table border-bottom-custom-table stats-table ${!screens.md ? "stats-table-mobile" : ""}`,
          scroll: { x: "max-content" },
          rowClassName: "cursor-pointer"
        }
      ),
      /* @__PURE__ */ jsx(
        Text,
        {
          type: "secondary",
          style: {
            padding: screens.md ? 16 : 12,
            borderRadius: "var(--border-radius-s-m)",
            background: "var(--color-bg-solid)",
            color: "var(--color-text-secondary)",
            fontSize: screens.md ? void 0 : 12
          },
          children: t("stats_updated_note")
        }
      )
    ] })
  ] });
};
var stdin_default = memo(StatsTable);
export {
  stdin_default as default
};
